import { Stage } from '../../constants/configurations';

// Cognito User Pool + Hosted UI that authenticates the Media Processing pages. Both
// external users (email/password) and internal users ("Sign in with Federate" on the
// Hosted UI) sign in here. Every other Portal page keeps logging in through Federate
// directly (see authConfig.ts).
//
// Values come from the AWSGCRContentFlywheel-ExternalAuth-<stage> stack CfnOutputs
// (AWSGCRContentFlywheelCDK, lib/stacks/external_auth.ts). Only Global beta
// (account 790317643200, us-east-1) is deployed; a stage without an entry keeps
// Media Processing on the existing Federate + SigV4 path.
export interface ExternalAuthConfig {
  // Hosted UI domain, without scheme, e.g. cf-auth-beta.auth.us-east-1.amazoncognito.com
  hostedUiDomain: string;
  // Public App Client (no secret): Authorization Code + PKCE only.
  clientId: string;
}

const BETA_EXTERNAL_AUTH: ExternalAuthConfig = {
  hostedUiDomain: 'cf-auth-beta.auth.us-east-1.amazoncognito.com',
  clientId: '28h5eqm0msnkii15m2ol6sad9o',
};

export const EXTERNAL_AUTH_CONFIG_BY_STAGE: Partial<Record<Stage, ExternalAuthConfig>> = {
  // Local development (localhost:3000) uses the beta User Pool.
  [Stage.DEV]: BETA_EXTERNAL_AUTH,
  [Stage.BETA]: BETA_EXTERNAL_AUTH,
};

export const COGNITO_CALLBACK_PATH = '/cognito/callback';

export const COGNITO_SCOPES = 'openid email profile';
